import type { KeyboardEvent, ReactNode } from "react";

type PromptInputProps = {
  children: ReactNode;
  className?: string;
};

export function PromptInput({ children, className = "" }: PromptInputProps) {
  return <div className={`pk-prompt ${className}`}>{children}</div>;
}

type TextareaProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder: string;
  label: string;
};

export function PromptInputTextarea({ id, value, onChange, onSubmit, placeholder, label }: TextareaProps) {
  const onKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      onSubmit();
    }
  };

  return (
    <>
      <label className="pk-prompt-label" htmlFor={id}>{label}</label>
      <textarea
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={onKeyDown}
        rows={1}
        placeholder={placeholder}
      />
    </>
  );
}

export function PromptInputActions({ children }: { children: ReactNode }) {
  return <div className="pk-prompt-actions">{children}</div>;
}

export function PromptInputAction({ children, label, onClick }: { children: ReactNode; label: string; onClick?: () => void }) {
  return (
    <button type="button" className="pk-prompt-action" aria-label={label} title={label} onClick={onClick}>
      {children}
    </button>
  );
}
